import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FocusOnLoadModule } from '../focus-on-load/focus-on-load.module';
import { KeyboardFocusTooltipModule } from '../keyboard-focus-tooltip/keyboard-focus-tooltip.module';
import { IconFontComponent } from './icon-font.component';

@NgModule({
    imports: [
        CommonModule,
        FocusOnLoadModule,
        KeyboardFocusTooltipModule
    ],
    declarations: [
        IconFontComponent
    ],
    exports: [
        IconFontComponent
    ]
})
export class IconFontModule {
}
